import PaymentMethod from './PaymentMethod'

export default class BumperBNPLPaymentMethod extends PaymentMethod {
  isAvailable() {
    return $('meta[name=ev_charger_bnpl_enabled]').attr('content') === 'true';
  }
}
